import React from "react";
import { useCookiePreferences } from "../context/CookieContext";

function CookieBanner() {
  const { showBanner, acceptAll, rejectAll, openPreferences } = useCookiePreferences();

  if (!showBanner) return null;

  return (
    <>
      {/* Backdrop overlay for better visibility */}
      <div className="fixed inset-0 z-[100] bg-slate-900/40 backdrop-blur-sm" />
      
      {/* Cookie Banner */}
      <div className="fixed inset-x-0 bottom-0 z-[101] px-4 pb-4 sm:pb-6">
        <div className="mx-auto max-w-4xl rounded-2xl border-2 border-slate-300 bg-white shadow-xl">
          <div className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between sm:p-6">
            <div className="space-y-3 flex-1">
              <p className="text-lg font-bold text-slate-900">Cookie Preferences</p>
              <p className="text-sm leading-relaxed text-slate-800">
                We only use essential cookies for authentication and secure sessions. You can accept,
                reject non-essential cookies, or manage your choices.
              </p>
              <a
                href="/cookie-policy.html"
                className="inline-block text-sm font-medium text-blue-600 underline-offset-2 hover:text-blue-700 hover:underline"
              >
                Read our cookie policy
              </a>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:flex-shrink-0">
              <button
                type="button"
                onClick={rejectAll}
                className="rounded-lg border-2 border-slate-400 bg-white px-5 py-2.5 text-sm font-bold text-slate-800 transition hover:border-slate-500 hover:bg-slate-50 active:bg-slate-100"
              >
                Reject
              </button>
              <button
                type="button"
                onClick={openPreferences}
                className="rounded-lg border-2 border-blue-400 bg-blue-50 px-5 py-2.5 text-sm font-bold text-blue-700 transition hover:border-blue-500 hover:bg-blue-100 active:bg-blue-200"
              >
                More options
              </button>
              <button
                type="button"
                onClick={acceptAll}
                className="rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-bold text-white shadow-md transition hover:bg-blue-700 active:bg-blue-800"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CookieBanner;

